import { throttle, clamp } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { scrollTop } from 'util/dom/scroll-pos';
import documentHeight from 'util/dom/document-height';
import scrollbarWidth from 'util/dom/scrollbar-width';


export default {
    data() {
        return {
            scrollLockPosition: null,
        };
    },
    computed: {
        ...mapGetters(['scroll']),
    },
    methods: {
        ...mapActions(['setScroll']),
        updateScroll() {
            const position = scrollTop();
            const progress = +clamp(position / (documentHeight() - window.innerHeight), 0, 1).toFixed(2);

            this.setScroll({
                position,
                progress,
                scrollbarWidth: scrollbarWidth(),
            });
        },
        throttledUpdateScroll: throttle(function() {
            this.updateScroll();
        }, 100),
    },
    mounted() {
        this.updateScroll();
        document.documentElement.classList.add('scroll-root');
        window.addEventListener('scroll', this.throttledUpdateScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.throttledUpdateScroll);
    },
    watch: {
        $route: {
            handler() {
                // NOTE: Don't reset scroll position after route change
                this.scrollLockPosition = 0;
                this.$nextTick(() => {
                    this.updateScroll();
                });
            },
        },
        'scroll.isLocked': {
            handler(val) {
                document.documentElement.classList[val ? 'add' : 'remove']('scroll-root__is-locked');
                document.body.style.top = val ? `${ this.scroll.position * -1 }px` : '';
                document.body.style.paddingRight = val ? `${ this.scroll.scrollbarWidth }px` : '';

                if (val) {
                    this.scrollLockPosition = this.scroll.position;
                } else {
                    // NOTE: Force a vuex update for all registered components
                    if (document.body.scrollTop === this.scrollLockPosition) {
                        window.scrollTo(null, this.scrollLockPosition + 1);
                        this.updateScroll();
                    }

                    window.scrollTo(null, this.scrollLockPosition);
                    this.updateScroll();
                }
            },
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/scroll/mixin.js